/**
 * Normalizes whitespace characters in a string by replacing non-breaking spaces with regular spaces
 */
const normalizeWhitespace = (text: string): string =>
  text.replace(/\u00A0/g, " ");

/**
 * Compares two strings after normalizing their whitespace characters
 * Used primarily for confirmation input validation in modals
 *
 * @param userInput - The input provided by the user
 * @param confirmPrompt - The expected confirmation text
 * @returns true if the normalized strings match, false otherwise
 */
export const compareNormalizedStrings = (
  userInput: string,
  confirmPrompt: string,
): boolean =>
  normalizeWhitespace(userInput) === normalizeWhitespace(confirmPrompt);
